import React, { useState, useEffect, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Loader from 'react-loader-spinner';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';
import FormControl from '@material-ui/core/FormControl';

import axios from 'axios';
import apiUrl from '../../constants.js';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
});

const useStyles = makeStyles ( (theme) => ({
  padding4Divs: {
    padding: '15px 0px',
  },
  padding4Labels: {
    padding: '10px 0px',
  },
  margin4Divs: {
    marginTop: '10px'
  },
  spinnerDiv: {
    height: '400px',
    width: '400px',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '150px'
  },
  imgPreview: {
    maxWidth: '100px',
    margin: 'auto'
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
    margin: '15px 0px'
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CompanyRegistrationForm = () => {
  const classes = useStyles();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleChange = e => {
    // setSettings({
    //   ...settings,
    //   [e.target.name]: e.target.value
    // });
  };

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Grid container spacing={1}>
        <Fragment>
          <Grid item xs={12} sm={6}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Titulo del sitio"
              name="title"
              type="text"
              autoFocus
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Sub-titulo del sitio"
              name="subTitle"
              type="text"
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Color del título (HEX)"
              name="titleColor"
              type="text"
            />
          </Grid>
        </Fragment>
      </Grid>
    </form>
  )
};

export default CompanyRegistrationForm;
